/**
 * @generated SignedSource<<bfeebc41361a657297243fe78f375b2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespShippingReturns_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBuyerProtectionBox_viewer">;
  readonly " $fragmentType": "PdpRespShippingReturns_viewer";
};
export type PdpRespShippingReturns_viewer$key = {
  readonly " $data"?: PdpRespShippingReturns_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespShippingReturns_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionBox_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "eba0aea17c7c042764226e523956f6b5";

export default node;
